module.exports = __webpack_public_path__ + "img/Logout.f2039ec5.svg";